import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { Banner } from "../../../ui/organisms/banner"
import { SelectCustom } from "../../../ui/molecules/select"
import { M024Type } from "../../../utils"
import { Calendar } from "../../../ui/molecules/calendar"

interface Props {
    close: () => void
}

export function PopupTypeM024(props: Props) {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    return (
        <div style={{ padding: '24px' }}>
            <div className="mt-3">
                <Calendar
                    label={'Data M024'}
                />
            </div>
            <div className="mt-4">
                <SelectCustom
                    label="Tipologia M024"
                    placeholder={'Tipologia'}
                    options={M024Type}
                    onChange={(value) => console.log()}
                />
            </div>
            <div className="mt-6" style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 10, paddingRight: 15, paddingBottom: '140px' }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Crea"
                        color="orange"
                        onClick={() => {
                            console.log()
                        }}
                    />
                </div>
            </div>

        </div>
    )


}